import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import EmptyList from "go-core/components/EmptyList";
import { LoadingContainer } from "go-core/components/Loading";
import { adminApi } from "../../../../../services/Api/Admin/adminApi";
import { partnerApi } from "../../../../../services/Api/Partner/partnerApi";
import { FileAttachmentApi, LoanApi } from "../../../../../services/Api/types";
import { selectPartner } from "../../../../../services/partner/selectors";
import LoanAttachments from "../LoanAttachments";

interface Props {
	loan: LoanApi;
	form: UseFormReturn<LoanApi>;
	handleUpdateLoan: (data: LoanApi) => void;
}

const LoanPreviewAttachmentsCard = ({ loan, form, handleUpdateLoan }: Props) => {
	const { t } = useTranslation("admin");
	const [loading, setLoading] = useState(false);
	const partner = useSelector(selectPartner);
	const { reset } = form;
	const { addSuccessFlash, addFlash } = useFlash();

	const updateLoan = async (attachments: FileAttachmentApi[]) => {
		const params = { include: "organization,partner,items,attachments" };
		try {
			setLoading(true);
			let resp: LoanApi;
			if (partner?.id) {
				resp = await partnerApi.updateLoan(partner.id, { ...loan, attachments }, params);
			} else resp = await adminApi.updateLoan({ ...loan, attachments }, params);
			handleUpdateLoan && handleUpdateLoan(resp);
			reset(resp);
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
		} catch (e) {
			handleError.alert(e, addFlash);
		}
		setLoading(false);
	};

	return loan.attachments ? (
		<Card>
			<Card.Body>
				{loan.attachments.length === 0 && loan.status === "CLOSED" ? (
					<>
						<h5>{t("modules.loan.field.attachments.title")}</h5>
						<EmptyList description={t("modules.loan.field.invalid_loan.title")} title={""} />
					</>
				) : (
					<>
						{loading ? (
							<LoadingContainer />
						) : (
							<LoanAttachments
								handleUpdate={updateLoan}
								loanStatus={loan.status}
								form={form}
								loanAcceptationStatus={loan.acceptation_status}
							/>
						)}
					</>
				)}
			</Card.Body>
		</Card>
	) : (
		<></>
	);
};

export default LoanPreviewAttachmentsCard;
